var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.674 1.822l10.505 1.852-1.852 10.505-10.505-1.853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.902 4.457a.555.555 0 00-.785-.008l-6.378 6.234-1.407-2.011a.555.555 0 10-.91.637l1.782 2.546a.566.566 0 00.843.078l6.847-6.69a.555.555 0 00.008-.786z",
    fill: "#647A97"
  }))));
}
export default SvgIconBack;